/**
 * Nomes de permissões usados nas verificações do frontend.
 * Devem ser idênticos aos cadastrados na tabela `permissions` do backend.
 */
export const PERMISSIONS = {
  /** Painel de correção manual de balanços (grupo "Configurações do Sistema"). */
  MANAGE_BALANCE_ADJUSTMENTS: "manage-balance-adjustments",

  /** Tela de acesso como usuário / personificação (grupo "Configurações do Sistema"). */
  IMPERSONATE_USERS: "impersonate-users",

  /** Normalização de vendas inconsistentes (grupo "Configurações do Sistema"). */
  MANAGE_SALE_NORMALIZATION: "manage-sale-normalization",

  /** Enviar e remover comprovantes de devolução (grupo "Devoluções"). */
  UPLOAD_DEVOLUTION_RECEIPT: "upload-devolution-receipt",
} as const;
